import * as types from "./actionTypes";

export const setAlert = (alerts) => {
  return {
    type: types.ALERT,
    payload: alerts,
  };
};
